import { Box } from "@mui/material"
import { StyledLogin } from "./Login.styled"
import background from "../../Images/maskersbackgroundimg.png"
import { LoginForm } from "../../Components/LoginForm/Loginform"
import { useEffect } from "react"
import { useProfile } from "../../stores/useProfile"
import { useNavigate } from "react-router-dom"

export const LoginPage = () => {
    const {user} = useProfile();
    const navigate = useNavigate();


    useEffect(() => {
        if (user) navigate("/admin")
    }, [user])

    return <StyledLogin>
        <Box className="backgroundWrapper">
            <img src={background}/>
        </Box>
        <LoginForm />
    </StyledLogin>
}